import axios from 'axios';
import { toast } from 'react-toastify';
import countries from 'countries-list';
import { useTranslation } from 'react-i18next';

export const addNewCustomers = async ({
  values,
  userID,
  setLoading,
  setShowDialog,
  fetchCustomers,
  setCustomers,
  t,
}) => {
  const isBusiness = values?.accountType != '1';
  const isVATRegistered = values?.isVATRegistred === 'true' || values?.isVATRegistred === true;

  if (isBusiness && isVATRegistered && !values?.vatNumber) {
    return toast.error(t('Please enter your VAT number'));
  }

  let countryCode = Object.entries(countries.countries).find(
    ([, val]) => val.name === values.country
  )?.[0] || (values.country === 'USA' ? 'US' : '');

  if (!isBusiness || !isVATRegistered) {
    values.vatNumber = '';
  } else {
        values.vatNumber = values?.vatCountryCode + values.vatNumber;
  }

  try {
    setLoading(true);
    const res = await axios.post('/admin/user/add-customer', {
     countryCode: values.vatCountryCode,
      ...values,
      id: 0,
      createdBy: userID,
    });

    if (res.data.response) {
      setShowDialog(false);
      fetchCustomers();
      toast.success(t('Added new customer successfully'));
    } else {
      throw new Error(res.data.message);
    }
  } catch (err) {
    setCustomers([]);
    setLoading(false);
    toast.error(err?.response?.data?.message || err?.message);
  }
};
